import { render, staticRenderFns } from "./CloudBandDetail.vue?vue&type=template&id=53c588f6"
import script from "./CloudBandDetail.vue?vue&type=script&lang=ts"
export * from "./CloudBandDetail.vue?vue&type=script&lang=ts"
import style0 from "./CloudBandDetail.vue?vue&type=style&index=0&id=53c588f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports